<modal #modal modalClass="company-picker-modal">
    <modal-header>
        <div class="row w-100 mx-0">
            <h4 class="modal-title mb-4 px-0">Companies</h4>
            <form (submit)="filterCompanies()" novalidate class="form-group display-flex flex-column w-100">
                <div class="display-flex flex-row w-100 mb-2">
                        <label class="me-2 filter-label">Company Name:</label>
                        <input type="text"
                               placeholder="Search By Name"
                               class="form-control"
                               [formControl]="searchBox" style="">
                </div>

                <div class="display-flex flex-row w-100 mb-2">
                        <label class="me-2 filter-label">Company Category:</label>
                        <select [formControl]="companyCategoryControl" class="form-control w-100">
                            <option [ngValue]="null" disabled>Choose a Company Category</option>
                            <option *ngFor="let option of categoryTypesSelect"
                                    [value]="option.key">{{ option.value }}
                            </option>
                        </select>
                </div>
                <div class="display-flex flex-row w-100 justify-content-end">
                    <button type="submit" class="btn btn-primary me-2">Search</button>
                    <button type="button" (click)="resetFilters()" class="btn btn-secondary">Clear</button>
                </div>
            </form>
        </div>
    </modal-header>
    <modal-body>
        <table-dynamic id="datatable-table"
                       class="table table-striped table-hover"
                       [currentPage]="currentPage"
                       [totalCount]="totalCount"
                       [headers]="headers"
                       (pageChanged)="setPage($event)"
                       (limitChange)="setLimit($event)">
            <tr *ngFor="let company of companies" [ngClass]="{selected: company == selectedRow}"
                (click)="setClickedRow(company)">
                <td><span>{{ company.name }}</span></td>
                <td><span>{{ getLastUsedDate(company.lastUsedDate) }}</span></td>
                <td><span>{{ company.categoryLabel }}</span></td>
            </tr>
        </table-dynamic>
    </modal-body>
    <modal-footer>
        <button *ngIf="showNoCompany" type="button" class="btn btn-danger me-auto"
                (click)="resetClicked()">No Company
        </button>
        <button type="button" [disabled]="!selectedRow" class="btn btn-primary" (click)="okClicked(selectedRow)">Ok
        </button>
        <button type="button" class="btn btn-default" (click)="cancelClicked()">Cancel</button>
    </modal-footer>
</modal>
